import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import TopBar from "../components/layout/TopBar";
import useSeo from "../hooks/useSeo";

export default function KVKK() {
  useSeo({
    title: "KVKK & Çerez Politikası | Otel Pro",
    description: "6698 sayılı Kişisel Verilerin Korunması Kanunu kapsamında aydınlatma metni ve çerez politikamız.",
  });

  return (
    <>
      <TopBar />
      <Header />
      <main className="min-h-screen bg-softbg py-16" data-testid="kvkk-page">
        <div className="max-w-3xl mx-auto px-6 bg-white rounded-xl p-8 md:p-12 border border-gray-100 shadow-sm">
          <div className="text-xs uppercase tracking-[0.18em] text-gold mb-2">Yasal</div>
          <h1 className="heading-serif text-3xl md:text-4xl text-navy mb-6">
            KVKK Aydınlatma Metni &amp; Çerez Politikası
          </h1>

          <div className="prose prose-sm max-w-none text-gray-700 space-y-4">
            <p>
              Otel Pro olarak; 6698 sayılı Kişisel Verilerin Korunması Kanunu
              ("KVKK") kapsamında veri sorumlusu sıfatıyla, kişisel verilerinizin
              işlenmesine ilişkin aşağıdaki aydınlatma metni ile bilgilendirmek
              isteriz.
            </p>

            <h2 className="heading-serif text-xl text-navy pt-3">1. İşlenen Kişisel Veriler</h2>
            <p>
              Teklif formu, iletişim formu ve danışmanlık talepleri aracılığıyla
              bizimle paylaştığınız ad-soyad, şirket adı, e-posta, telefon ve
              proje detayları kişisel veri niteliğindedir. Siteyi ziyaret
              ettiğinizde oturum bilgisi, cihaz bilgisi ve kullanım analitiği
              çerezler aracılığıyla toplanır.
            </p>

            <h2 className="heading-serif text-xl text-navy pt-3">2. İşleme Amacı</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>Teklif ve danışmanlık taleplerinize zamanında dönüş yapmak</li>
              <li>Ekipman tedarik sürecinizi planlamak ve yürütmek</li>
              <li>Site deneyimini kişiselleştirmek ve iyileştirmek</li>
              <li>Yasal yükümlülükleri yerine getirmek</li>
            </ul>

            <h2 className="heading-serif text-xl text-navy pt-3">3. Çerez (Cookie) Kullanımı</h2>
            <p>
              Sitemizde üç tip çerez kullanılır: (a) <strong>zorunlu çerezler</strong>{" "}
              — oturum ve temel işlevsellik için; (b) <strong>performans çerezleri</strong>{" "}
              — anonim analitik için; (c) <strong>tercih çerezleri</strong> —
              dil/karşılaştırma sepeti gibi seçimlerinizi hatırlamak için.
              Yalnızca zorunlu çerezlere izin vererek siteyi kullanabilir ya da
              tüm çerezleri kabul edebilirsiniz.
            </p>

            <h2 className="heading-serif text-xl text-navy pt-3">4. Veri Saklama &amp; Aktarım</h2>
            <p>
              Verileriniz yalnızca açıklanan amaçlar için gerekli olduğu süre
              boyunca saklanır ve üçüncü taraflarla — SendGrid (e-posta iletimi),
              barındırma hizmet sağlayıcımız — aynı güvenlik standartlarıyla
              paylaşılır. KVKK md. 8-9 kapsamında izinsiz üçüncü taraflara veri
              aktarımı yapılmaz.
            </p>

            <h2 className="heading-serif text-xl text-navy pt-3">5. Haklarınız</h2>
            <p>
              KVKK madde 11 uyarınca; verilerinize erişme, düzeltme, silme,
              işlenmesine itiraz etme ve aktarımını talep etme haklarına sahipsiniz.
              Taleplerinizi{" "}
              <a href="mailto:info@otel-ekipmanlari.com" className="text-teal underline">
                info@otel-ekipmanlari.com
              </a>{" "}
              adresine iletebilirsiniz.
            </p>

            <h2 className="heading-serif text-xl text-navy pt-3">6. İletişim</h2>
            <p>
              Veri Sorumlusu: <strong>Otel Pro Danışmanlık</strong> ·{" "}
              <a href="mailto:info@otel-ekipmanlari.com" className="text-teal">info@otel-ekipmanlari.com</a>{" "}
              · 0532 737 13 06
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
